// extracted by mini-css-extract-plugin
export var container = "Faq-module--container--b3b7c";
export var detailsContainer = "Faq-module--detailsContainer--8a701";
export var summary = "Faq-module--summary--6b502";